window.apisExactExportBusinessTypesDetailFormatter = function(value, row) {
    let html = '';
    let data = JSON.parse(row.data);
    if (data != null && Object.keys(data).length > 0) {
        html += '<div class="form-group">';
        html += "<label>"+__('Response')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.data+"</textarea>";
        html += '</div>';
        html += '<div class="mt-3"></div>';
        html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
        html += '<thead>';
        html += '<tr>';
        html += '<th>'+__('Code')+'</th>';
        html += '<th>'+__('Description')+'</th>';
        html += '<th>'+__('Short Description')+'</th>';
        html += '<th>'+__('Country')+'</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        data.sort((a, b) => parseFloat(a.Code) - parseFloat(b.Code));
        data.sort((a, b) => a.Country.localeCompare(b.Country));
        for (let i = 0; i < data.length; i++) {
            let businessType = data[i];
            html += '<tr>';
            html += '<td>'+businessType.Code+'</td>';
            html += '<td>'+businessType.Description+'</td>';
            html += '<td>'+businessType.ShortDescription+'</td>';
            html += '<td>'+businessType.Country+'</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
    }
    return html;
};

